export enum BidPackageStep {
  PACKAGE_DETAILS = "packageDetails",
  REVIEW_SCOPE = "reviewScope",
  SELECT_BIDDERS = "selectBidders",
  REVIEW_AND_DOWNLOAD = "reviewAndDownload",
}
